module.exports = __webpack_public_path__ + "static/media/tybalt.7dce9741.png";